export interface StackFloorRuleConfigEntity {
  floorRuleId: string
  adUnitIds: string[]
}

export interface StackFloorRuleConfig {
  standardFloorRuleId: string
  specificFloorRuleConfigs?: StackFloorRuleConfigEntity[] | null
}

export const FLOOR_PRICE_NO_RULE_ID = 'NO_RULE'
